/**
 * Default export pour l'auto-discovery `apps/web/src/routes/modules.ts`.
 *
 * Onglet « Factures de vente » (icône lucide `receipt`, celle du mockup-contrat
 * du 07/10), visible à TOUT compte connecté (spec D11/D7 : tout le monde voit,
 * un admin génère — absent de `apps/web/src/lib/acces.ts` `ECRANS_RESERVES_ADMIN`).
 */
import { lazy, Suspense } from 'react';
import type { ModuleRoute } from '@herbo/module-route';

const FacturesVentes = lazy(() => import('./pages/FacturesVentes'));

const route: ModuleRoute = {
  path: 'factures-ventes',
  label: 'Factures de vente',
  icon: 'receipt',
  element: (
    <Suspense fallback={<div className="px-6 py-8 text-sm text-slate-500">Chargement des factures de vente…</div>}>
      <FacturesVentes />
    </Suspense>
  ),
};

export default route;
